export default {
      id: "cross-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#cross-usage",
      toString: function () {
        return this.url;
      }
    }